import { Flex, Stack, VStack, Text, Divider, Box } from "@chakra-ui/react";
import Link from "components/Link";
import Image from "components/Image";
import Button from "components/Button";
import { useRouter } from "next/router";
import {
  WhatsappIcon,
  LinkedinIcon,
  LinkedinWhiteIcon,
} from "components/Icons";
import logoImage from "../../../public/logo-101digital-footer.png";
import logoImageWhite from "../../../public/logo-101digital-footer-white.png";
// import logoIso from "../../../public/logo-iso-new.jpeg";
// import logoFSQSRegistered from "../../../public/logo-fsqs-registered.svg";
import CircuitImage from "../../../public/circuit-board.png";

const links = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "Products",
    href: "/products",
  },
  {
    title: "Approach",
    href: "/approach",
  },
  {
    title: "People",
    href: "/people",
  },
  {
    title: "Success Stories",
    href: "/success-stories",
  },
];

const commitments = [
  {
    title: "Modern Slavery Act",
    href: "/modern-slavery-act",
  },
  {
    title: "Diversity Policy",
    href: "/diversity-policy",
  },
  {
    title: "Equal Opportunities",
    href: "/equal-opportunities",
  },
  {
    title: "Responsible Tax Management",
    href: "/responsible-tax-management",
  },
];

const Footer = () => {
  const router = useRouter();
  const pagesNotContainSection1 = [
    "/contact",
    "/privacy-policy",
    "/terms-of-service",
    "/modern-slavery-act",
    "/diversity-policy",
    "/equal-opportunities",
    "/responsible-tax-management",
  ];
  const shouldHideSection1 = pagesNotContainSection1.includes(router.pathname);
  const pagesContainSecondarySection2 = [
    "/privacy-policy",
    "/terms-of-service",
    "/modern-slavery-act",
    "/diversity-policy",
    "/equal-opportunities",
    "/responsible-tax-management",
  ];
  const shouldShowSecondarySection2 = pagesContainSecondarySection2.includes(
    router.pathname
  );

  return (
    <>
      {/* SECTION 1 */}

      {!shouldHideSection1 && (
        <Flex
          pos="relative"
          w="100%"
          minH={["250px", null, null, null, null, "400px"]}
          overflow="hidden"
        >
          <Flex
            pos="absolute"
            w="1920px"
            left="50%"
            transform="translateX(-50%)"
            top="0"
            zIndex="-1"
            justify="center"
            bgColor="secondary"
          >
            <Image
              src={CircuitImage}
              alt="101Pay"
              objectFit="cover"
              objectPosition="center"
            />
          </Flex>
          <Flex
            direction={["column", null, null, null, null, "row"]}
            maxW="1156px"
            width="100%"
            align="center"
            justify="space-between"
            margin="auto"
            px="16px"
          >
            <Text
              fontSize={["32px", null, null, null, null, "48px"]}
              fontWeight="300"
              maxW="1023px"
              mb="41.2px"
              textAlign={["center", null, null, null, null, "unset"]}
            >
              <Text as="span" fontWeight="300" color="white">
                Let&apos;s build
              </Text>{" "}
              the next
              <br />
              generation Digital Platforms
            </Text>
            <Button
              href="/contact"
              minW={["292px", null, null, null, null, "347px"]}
              onClick={() => router.push("/contact")}
            >
              Talk to us
            </Button>
          </Flex>
        </Flex>
      )}
      {/* SECTION 2 */}
      <Flex
        bgColor={shouldShowSecondarySection2 ? "primary" : "white"}
        w="100%"
        justify="center"
        marginTop="auto"
      >
        <Flex
          flexDir="column"
          w="100%"
          maxW="1156px"
          pt={["74px", null, null, null, null, "32px"]}
          pb={["41px", null, null, null, null, "25px"]}
        >
          <Flex
            justify="center"
            flexDir={["column", null, null, null, null, "row"]}
            px="16px"
          >
            <Stack
              flex="1"
              direction={["column", null, null, null, null, "row"]}
              align="center"
              spacing="56px"
              mb={["35.51px", null, null, null, null, 0]}
              justify="space-between"
              p={["0 15px 0 15px", null, null, null, null, 0]}
            >
              <Flex mb={["36.03px", null, null, null, null, 0]}>
                {shouldShowSecondarySection2 ? (
                  <Image
                    src={logoImageWhite}
                    alt="101Digital"
                    w={["209px", null, null, null, null, "251px"]}
                    h={["39.97px", null, null, null, null, "48px"]}
                    objectPosition="center"
                  />
                ) : (
                  <Image
                    src={logoImage}
                    alt="101Digital"
                    w={["209px", null, null, null, null, "251px"]}
                    h={["39.97px", null, null, null, null, "48px"]}
                    objectPosition="center"
                  />
                )}
              </Flex>
            </Stack>
            <Divider
              display={["none", null, null, null, null, "block"]}
              orientation="vertical"
              ml="54px"
              mr="48.5px"
              borderColor={shouldShowSecondarySection2 ? "white" : "primary"}
            />
            <Stack
              direction={["column", null, null, null, null, "row"]}
              spacing={["52px", null, null, null, null, "39px"]}
              mb="60px"
            >
              <Flex
                px={["22px", null, null, null, null, 0]}
                flexDir="column"
                minW="153px"
                order={1}
              >
                <Text
                  display={["none", null, null, null, null, "flex"]}
                  textStyle="navLink"
                  fontWeight="700"
                  mb="26px"
                  textAlign={["center", null, null, null, null, "left"]}
                  color={shouldShowSecondarySection2 ? "white" : "primary"}
                >
                  Links
                </Text>

                <VStack
                  spacing="21px"
                  align={["center", null, null, null, null, "flex-start"]}
                >
                  {links.map((n, idx) => (
                    <Link
                      key={idx}
                      href={n.href}
                      textStyle="navLink"
                      fontWeight="300"
                      color={shouldShowSecondarySection2 ? "white" : "primary"}
                    >
                      {n.title}
                    </Link>
                  ))}
                </VStack>
              </Flex>
              <Flex
                px={["22px", null, null, null, null, 0]}
                flexDir="column"
                minW="165px"
                order={[2, null, null, null, null, 4]}
              >
                <Text
                  textStyle="navLink"
                  fontWeight="700"
                  mb="20px"
                  color={shouldShowSecondarySection2 ? "white" : "primary"}
                  textAlign={["center", null, null, null, null, "start"]}
                >
                  Our Commitments
                </Text>
                <VStack
                  spacing="24px"
                  align={["center", null, null, null, null, "flex-start"]}
                >
                  {commitments.map((n, idx) => (
                    <Link
                      key={idx}
                      href={n.href}
                      textStyle="navLink"
                      fontWeight="300"
                      color={shouldShowSecondarySection2 ? "white" : "primary"}
                    >
                      {n.title}
                    </Link>
                  ))}
                </VStack>
              </Flex>
              <Flex
                px={["27px", null, null, null, null, 0]}
                flexDir="column"
                order={3}
              >
                <Text
                  textStyle="navLink"
                  fontWeight="700"
                  mb="25px"
                  color={shouldShowSecondarySection2 ? "white" : "primary"}
                  textAlign={["center", null, null, null, null, "start"]}
                >
                  Get in touch
                </Text>
                <Flex justify="center">
                  <Box px="17.58px">
                    <WhatsappIcon
                      cursor="pointer"
                      onClick={() =>
                        window.open("https://wa.me/6583390399", "_blank")
                      }
                    />
                  </Box>
                  <Box
                    px="17.58px"
                    display={["inline", null, null, null, null, "none"]}
                  >
                    {shouldShowSecondarySection2 ? (
                      <LinkedinWhiteIcon
                        cursor="pointer"
                        onClick={() =>
                          window.open(
                            "https://www.linkedin.com/company/101digital/mycompany/",
                            "_blank"
                          )
                        }
                      />
                    ) : (
                      <LinkedinIcon
                        cursor="pointer"
                        onClick={() =>
                          window.open(
                            "https://www.linkedin.com/company/101digital/mycompany/",
                            "_blank"
                          )
                        }
                      />
                    )}
                  </Box>
                </Flex>
              </Flex>
              <Flex
                display={["none", null, null, null, null, "flex"]}
                px={["27px", null, null, null, null, 0]}
                flexDir="column"
                order={2}
              >
                <Text
                  textStyle="navLink"
                  fontWeight="700"
                  mb="25px"
                  color={shouldShowSecondarySection2 ? "white" : "primary"}
                  textAlign={["center", null, null, null, null, "left"]}
                >
                  Connect with us
                </Text>
                <Box textAlign="center">
                  {shouldShowSecondarySection2 ? (
                    <LinkedinWhiteIcon
                      cursor="pointer"
                      onClick={() =>
                        window.open(
                          "https://www.linkedin.com/company/101digital/",
                          "_blank"
                        )
                      }
                    />
                  ) : (
                    <LinkedinIcon
                      cursor="pointer"
                      onClick={() =>
                        window.open(
                          "https://www.linkedin.com/company/101digital/",
                          "_blank"
                        )
                      }
                    />
                  )}
                </Box>
              </Flex>
            </Stack>
          </Flex>
          <Divider
            display={["none", null, null, null, null, "block"]}
            orientation="horizontal"
            mt="30px"
            mb="23.5px"
            borderColor={shouldShowSecondarySection2 ? "white" : "primary"}
          />
          <Flex
            flexDir={["column", null, null, null, null, "row"]}
            align={["center", null, null, null, null, "center"]}
            justify="space-between"
            px="16px"
            position="relative"
          >
            <Text
              as="span"
              fontSize="1rem"
              fontWeight="400"
              lineHeight="1.875rem"
              color={shouldShowSecondarySection2 ? "white" : "gray"}
              order={[1, null, null, null, null, 0]}
            >
              101Digital © {new Date().getFullYear()}
            </Text>
            <Flex
              order={[0, null, null, null, null, 1]}
              flexDir={["column", null, null, null, null, "row"]}
              align="center"
              mb={["72px", null, null, null, null, 0]}
            >
              <Link
                href="/privacy-policy"
                fontSize="1rem"
                fontWeight="400"
                lineHeight="1.875rem"
                color={shouldShowSecondarySection2 ? "white" : "gray"}
              >
                Privacy Policy
              </Link>
              <Divider
                display={["none", null, null, null, null, "block"]}
                orientation="vertical"
                mx="30px"
                h="15px"
                borderColor={shouldShowSecondarySection2 ? "white" : "gray"}
              />
              <Link
                href="/terms-of-service"
                fontSize="1rem"
                fontWeight="400"
                lineHeight="1.875rem"
                color={shouldShowSecondarySection2 ? "white" : "gray"}
              >
                Terms of Service
              </Link>
              <Flex
                position={["static", null, null, null, null, "absolute"]}
                right="111px"
                top="-94px"
                align="center"
              >
                <a
                  href="https://www.iafcertsearch.org/certified-entity/maG3b5ze2cHNcKYEssHi533c"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="data:image/jpeg;base64,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"
                    alt="isoLogo"
                    width={"58px"}
                    height={"60px"}
                  />
                </a>
                <img
                  src="data:image/jpeg;base64,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"
                  alt=""
                  width={"58px"}
                  height={"60px"}
                />
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default Footer;
